import { environmentBase } from '@lr/core';

/**
 * Test config for attorney portal when served at root (e.g. Azure Static Web App).
 * Same as environment.test but redirectUri is /callback so Auth0 redirects to root path.
 */
const portalOverrides = {
  auth: {
    ...environmentBase.auth,
    portalKey: 'attorney',
    redirectUri: window.location.origin + '/callback',
    clientId: 'FcmFKGKxgbv8OBeOptVHgdIeBg1Ftjbb'
  }
};

export const environment = {
  ...environmentBase,
  ...portalOverrides
};
